module.exports = __webpack_public_path__ + "static/img02__sp-0526cbb2cbd6addee1ca1bf669be90be.svg";